const styles = (theme) => ({
  root: {
    ...theme.mixins.modal.dialog.root,
    overflowY: 'scroll',
  },
});

export default styles;
